import styled from "styled-components";

export const SearchButtonContainer = styled.div`
  font-size: 0;
  padding: 10px;
  display: block;

  svg {
    width: 18px;
    height: 18px;

    path {
      stroke: ${({ theme }) => theme.colors.globalTopbar.iconsColor};
    }
  }
`;
